<h3 mat-dialog-title>{{Title}}</h3>

<mat-dialog-content class="edit-dialog">
    <div fxLayout="row" fxLayoutAlign="center center">
        <busy-indicator *ngIf="loading"></busy-indicator>
    </div>

    <div *ngIf="!loading" fxFlexFill fxLayoutAlign="space-around center">
        <fieldset class="fsNoFormat">
            <form #form="ngForm">
                <metadata-panel ngModelGroup="pnl_editDialog" *ngIf="!CustomEdit" [metadata]="item.Metadata" [model]="item.Entity">
                </metadata-panel>

                <div *ngIf="CustomEdit">

                    <div *ngIf="!hasCustomView">
                        <!-- ! TODO - remove after conversion -->
                        NO CUSTOM VIEW DEFINED FOR '{{editComponent}}'
                    </div>
                    <custom-view-downgrade *ngIf="hasCustomView" [component]="editComponent" [custom-data-binding]="customDataBinding">
                    </custom-view-downgrade>
                </div>

            </form>
        </fieldset>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button mat-dialog-close telemetry="Submission-EditCancel">
        Cancel
    </button>

    <button mat-raised-button color="primary" [disabled]="!CanSave" (click)="save()" telemetry="Submission-EditSave">
        Save
    </button>
</mat-dialog-actions>
